var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"secondary",attrs:{"pa-16":"","fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-img',{attrs:{"src":require("@/assets/logo/chordata-logo.png"),"max-width":"220"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }